import { useEventListener } from "./useEventListener"

/**
 * Easily retrieve window dimensions with this Hook React which also works onRezise
 */
export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = React.useState<WindowSize>({
    width: 0,
    height: 0,
  })

  const handleSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  useEventListener("resize", handleSize)

  // Set size at the first client-side load
  React.useLayoutEffect(() => {
    handleSize()
  }, [])

  return windowSize
}

/**
 * types
 */
interface WindowSize {
  width: number
  height: number
}
